<template>
    <section>
		<app-loading :show-loading="loadingButton" />
		<div v-if="showParentView('page-list-billing')">
			<header-page
				name="billings"
				:title="$route.meta.title"
			/>
			<v-layout pt-4 pb-2 pl-5>
				<v-flex xs2>
					<v-select
						box
						background-color="white"
						clearable
						class="body-1"
						hide-details
						item-text="name"
						item-value="id"
						label="Entorno"
						:items="typeDomains"
						return-object
						v-model="typeDomain"
						@input="setDomain"
					></v-select>
				</v-flex>
				<v-flex xs2 ml-3>
					<v-select
						box
						background-color="white"
						clearable
						class="body-1"
						hide-details
						item-text="name"
						item-value="id"
						label="Tipo de Doc."
						:items="typeDocuments"
						v-model="params.typeDocument"
					></v-select>
				</v-flex>
			</v-layout>
			<v-layout pt-4 pb-2 pl-5 justify-space-between>
				<v-flex xs2>
					<date-component
						label="Fecha de inicio"
						:date-formatted="params.startDate"
						model="startDate"
						@input="setDate({ model: 'startDate', value: $event })"
					/>
				</v-flex>
				<v-flex xs2>
					<date-component
						label="Fecha de fin"
						:date-formatted="params.endDate"
						model="endDate"
						@input="setDate({ model: 'endDate', value: $event })"
					/>
				</v-flex>
				<v-flex xs2>
					<date-component
						label="Fecha de Envió"
						:date-formatted="params.dateBilling"
						model="dateBilling"
						@input="setDate({ model: 'dateBilling', value: $event })"
					/>
				</v-flex>
				<v-flex xs3 ml-3 pt-3>
					<v-select
						background-color="white"
						box
						multiple
						clearable
						class="body-1"
						hide-details
						item-text="name"
						item-value="id"
						label="Estado"
						:items="states"
						return-object
						v-model="statusTax"
					></v-select>
				</v-flex>
				<v-flex xs2 ml-3 mt-3>
					<v-btn
						:disabled="loadingButton"
						class="btn-search"
						@click="setSearch">
							<v-icon>search</v-icon>
					</v-btn>
				</v-flex>
			</v-layout>
			<div class="px-5">
				<app-table
					class="my-5 is-not-selectable pb-4"
					:columns="columns"
					:current-page="currentPage"
					:rows="rows"
					:last-page="lastPage"
					@on-search-event="onSearch"
					@on-page="changePage"
				>
					<template slot="rows" slot-scope="props">
						<td
							class="is-not-selectable"
							v-show="showRow(columns, 1)"
						>
							{{ props.row.aclCode }}
						</td>
						<td v-show="showRow(columns, 2)">
							{{ props.row.ruc }}
						</td>
						<td v-show="showRow(columns, 3)">
							{{ props.row.rucName }}
						</td>
						<td v-show="showRow(columns, 4)">
							<button class="link-row" @click="goToDetailError(props.row)">
								{{ props.row.sumFac }}
							</button>
						</td>
						<td v-show="showRow(columns, 5)">
							<button class="link-row" @click="goToDetailError(props.row)">
								{{ props.row.sumNtc }}
							</button>
						</td>
						<td v-show="showRow(columns, 6)">
							<button class="link-row" @click="goToDetail(props.row)">
								{{ props.row.sumResumen }}
							</button>
						</td>
					</template>
				</app-table>
			</div>
		</div>
		<router-view></router-view>
    </section>
</template>

<script>
import { format } from 'date-fns';
import dateComponent from '@/components/shared/date-component';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import appLoading from '@/components/shared/app-loading';

function created() {
	this.loadResources();
}
async function loadBilling() {
	this.loadingButton = true;
	this.params.page = this.currentPage;
	const params = {
		typeDocument: this.params.typeDocument ? this.params.typeDocument.id : undefined,
		statusTax: this.statusTax && this.statusTax.length > 0 ? this.statusTax.map(p => p.id).join(',') : null,
		...this.params,
	};
	try {
		const response = await this.$httpSales.get('subsidiaries/PER/billing', { params });
		this.rows = response.data || [];
		this.lastPage = Number(response.headers['x-last-page']) || 0;
	} catch (error) {
		this.showError();
	} finally {
		this.loadingButton = false;
	}
}
function setSearch() {
	if (this.typeDomain.id === 1 || this.typeDomain.id === undefined) {
		this.$httpSales.defaults.baseURL = 'https://n1.sales.casamarketapp.com/';
	} else {
		this.$httpSales.defaults.baseURL = 'https://cm-sales.apprunn.net/';
	}
	this.loadBilling();
}
function setDate({ model, value }) {
	this.params[model] = format(value.value, 'YYYY-MM-DD');
}
function onSearch(search) {
	this.params.search = search ? search.trim() : null;
	this.loadBilling();
}
function changePage(page) {
	this.currentPage = page;
	this.loadBilling();
}
function goToDetail({ id }) {
	this.goTo('detail-billing', { params: { id, date: this.params.dateBilling, idsStatus: this.statusTax, domain: this.domain } });
}
function goToDetailError({ id }) {
	this.goTo('detail-error-billing', { params: { id, date: this.params.dateBilling, idsStatus: this.statusTax, domain: this.domain } });
}
function data() {
	return {
		columns: [
			{ id: 1, name: 'Código', checked: true, visible: true },
			{ id: 2, name: 'RUC', checked: true, visible: true },
			{ id: 3, name: 'Nombre', checked: true, visible: true },
			{ id: 4, name: 'FACT ERROR', checked: true, visible: true },
			{ id: 5, name: 'NTC ERROR', checked: true, visible: true },
			{ id: 6, name: 'RESUMEN ERROR', checked: true, visible: true },
		],
		states: [
			{
				id: 1,
				name: 'Sin Enviar',
			},
			{
				id: 2,
				name: 'En Proceso',
			},
			{
				id: 3,
				name: 'Validado',
			},
			{
				id: 4,
				name: 'Error',
			},
			{
				id: 5,
				name: 'Firmado',
			},
			{
				id: 6,
				name: 'Error al Enviar',
			},
			{
				id: 7,
				name: 'Error de SUNAT',
			},
			{
				id: 8,
				name: 'Pendiente respuesta SUNAT',
			},
			{
				id: 9,
				name: 'Expirado (+30 días)',
			},
			{
				id: 10,
				name: 'No usa facturación',
			},
			{
				id: 11,
				name: 'Rechazado por SUNAT',
			},
		],
		currentPage: 1,
		lastPage: 0,
		loadingButton: false,
		params: {
			typeDocument: null,
			dateBilling: null,
			startDate: null,
			endDate: null,
			limit: 20,
			page: 1,
		},
		typeDomains: [],
		typeDomain: null,
		typeDocument: null,
		typeDocuments: [
			{
				id: 1,
				name: 'Documento de Venta',
			},
			{
				id: 2,
				name: 'Resumen de Venta',
			},
			{
				id: 3,
				name: 'Ambos',
			},
			{
				id: 4,
				name: 'Boleta',
			},
		],
		rows: [],
		statusTax: [],
		domain: '',
	};
}
export default {
	name: 'page-list-billing',
	components: {
		appTooltipButton,
		dateComponent,
		appLoading
	},
	created,
	data,
	methods: {
		changePage,
		goToDetail,
		goToDetailError,
		loadBilling,
		onSearch,
		setDate,
		setSearch,
		setDomain(e) {
			this.domain = e.endPoint;
			this.$httpSales.defaults.baseURL = e.endPoint;
			this.loadBilling();
		},
		async loadResources() {
			this.loadingButton = true;
			const { codeProject } = this.$route.params;
			try {
				const domains = await this.$http.get(`projects/${codeProject}/domains`);
				this.typeDomains = domains.data;
				this.typeDomain = this.typeDomains[0].id;
				this.domain = this.typeDomains[0].endPoint;
				this.$httpSales.defaults.baseURL = this.typeDomains[0].endPoint;
			} catch (err) {
				this.showError();
			} finally {
				this.loadingButton = false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.btn-search {
	background-color: map-get($colors, primary) !important;
	border-radius: 0px 5px 5px 0;
	height: 50px;
	width: 120px;
}
.link-row {
	border-bottom: 1px solid #2987e5;
	color: #2987e5;
}
</style>



// WEBPACK FOOTER //
// src/pages/billing/page-list-billing.vue